import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "cart-gift__cover" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
    key: 1,
    class: "cart-gift__title"
};
import Sprite from "../../../../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChooseGiftButton',
    props: {
        html: Boolean,
        inactive: Boolean,
        message: String,
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["cart-gift__top", { inactive: __props.inactive }]),
                type: "button"
            }, [
                _createElementVNode("span", _hoisted_1, [
                    _createVNode(Sprite, {
                        name: "gift",
                        size: 32
                    })
                ]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (__props.html && __props.message)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "cart-gift__title",
                        innerHTML: __props.message
                    }, null, 8 /* PROPS */, _hoisted_2))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "default", {}, () => [
                            _createTextVNode(_toDisplayString(__props.message), 1 /* TEXT */)
                        ])
                    ]))
            ], 2 /* CLASS */));
        };
    }
});
